import v from 'vudu';
import colors from './colors';
import layout from './layout';
import copy from './copy';
import breakpoints from './breakpoints';
import utils from './utils';

const buildStyles = () => {
  return Object.assign(
    v.config({ colors }),
    layout,
    copy,
    utils,
    {
      row: {
        paddingLeft: '20px',
        paddingRight: '20px',
        maxWidth: '1040px',
        margin: 'auto'
      },
      verticalCenter: {
        top: '50%',
        position: 'relative',
        transform: 'translateY(-50%)',
      }
    }
  );
};

const styles = buildStyles();
const classes = v(styles);

function format(classes) {
  return Array.isArray(classes) ? classes.join(' ') : Array.from(arguments).join(' ');
}

export { copy, colors, styles, classes, format, breakpoints, utils, };



// WEBPACK FOOTER //
// ./src/stylesheet/index.js